import React, { useState, useEffect } from 'react'
import { Container, Row, Col, Image } from "react-bootstrap";
import AboutBlock from './AboutBlock';
// import ContactForm from './ContactForm'
import { Link } from "react-router";

import pattern from "../../Assets/pattern.svg";
import indiaLocation from "../../Assets/india-location.png";
import bnglrLocation from "../../Assets/bnglr-location.png";
import vizagLocation from "../../Assets/vizag-location.png";

import './ContactStyle.css'

export default function Contact() {

    return (
        <div>
            <section className='section-hero'>
                <Container fluid className="header-section">
                    <Row style={{ background: "#1b3f38" }}>
                        <Col md={12} >
                            <div className="padding-section-large text-center d-flex flex-column text-white">
                                <div className="max-width-large mx-auto">
                                    <h1 className="heading-style-h1">Contact CeWaves</h1>
                                </div>
                                <div className='pt-2 max-width-medium mx-auto'>
                                    <p className="text-size-medium">Send us a message with any questions and our friendly staff will get back to you within 48 hours.</p>
                                </div>
                            </div>
                        </Col>
                        <div className='position-absolute top-0 left-0 w-100 h-100'>
                            <Image src={pattern} />
                        </div>

                    </Row>
                </Container >
            </section >
            <section className='px-5 padding-section-large'>
                <div className='locations-horizontal-wrap'>
                    <div className='contact_location'>
                        <div className="contact_text-wrap">
                            <h3 className="heading-style-h3">Bangalore</h3>
                            <p className="text-size-medium">Whitefield,<br />Karnataka</p>
                        </div>
                        <div className="contact_image-wrapper"><div className="image_ratio3-4"><img src={bnglrLocation} className="image-100-cover" /></div></div>
                    </div>
                    <div className='contact_location'>
                        <div className="contact_text-wrap">
                            <h3 className="heading-style-h3">Hyderabad</h3>
                            <p className="text-size-medium">Miyapur, <br /> Telangana</p>
                        </div>
                        <div className="contact_image-wrapper"><div className="image_ratio3-4"><img src={indiaLocation} className="image-100-cover" /></div></div>
                    </div>
                    <div className='contact_location'>
                        <div className="contact_text-wrap">
                            <h3 className="heading-style-h3">Vizag</h3>
                            <p className="text-size-medium">Seethammadhara, <br /> Andhrapradesh</p>
                        </div>
                        <div className="contact_image-wrapper"><div className="image_ratio3-4"><img src={vizagLocation} className="image-100-cover" /></div></div>
                    </div>
                </div>
            </section>
        </div>
    )
}
